/*============================================================================
  Cart upsells — recommended products in the cart drawer
  Fetches Shopify's product recommendations for the first cart item and renders
  tiles with a variant selector (options joined by " / ") and an Add button.
==============================================================================*/
(function () {
  'use strict';

  var MOUNT_SELECTOR = '[data-cart-upsells]';
  var LIMIT = 8;
  var lastProductId = null;

  function getMoneyFormat() {
    return window.theme && theme.settings ? theme.settings.moneyFormat : '${{amount}}';
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, getMoneyFormat());
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchCart() {
    if (window.theme && theme.cart && theme.cart.getCart) return theme.cart.getCart();
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function fetchRecommendations(productId) {
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + LIMIT + '&intent=related';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function buildVariantLabel(variant) {
    // Join all non-"Default" option values with " / "
    return variant.options
      .filter(function (o) { return o && o !== 'Default Title'; })
      .join(' / ') || variant.title;
  }

  function buildTile(product) {
    var variants = product.variants || [];
    if (!variants.length) return '';

    var firstVariant = variants[0];

    var image = product.featured_image
      ? '<img src="' + product.featured_image + '&width=120" alt="' + escHtml(product.title) + '" width="72" height="72" loading="lazy">'
      : '<div class="cart-upsells__tile-img-placeholder"></div>';

    // Price from first variant; update dynamically on select change
    var comparePrice = firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price
      ? '<s class="cart-upsells__tile-compare">' + escHtml(formatMoney(firstVariant.compare_at_price)) + '</s> '
      : '';
    var price = '<span class="cart-upsells__tile-price-current">' + escHtml(formatMoney(firstVariant.price)) + '</span>';

    // Build variant options map for price updates
    var variantData = JSON.stringify(variants.map(function (v) {
      return { id: v.id, price: v.price, compare_at_price: v.compare_at_price, available: v.available };
    })).replace(/"/g, '&quot;');

    // Build select options
    var options = variants.map(function (v) {
      var label = buildVariantLabel(v);
      var disabled = !v.available ? ' disabled' : '';
      return '<option value="' + v.id + '"' + disabled + '>' + escHtml(label) + (v.available ? '' : ' — Sold out') + '</option>';
    }).join('');

    var hasOneVariant = variants.length === 1 && variants[0].title === 'Default Title';

    return (
      '<div class="cart-upsells__tile">' +
        '<a href="/products/' + escHtml(product.handle) + '" class="cart-upsells__tile-img-wrap">' + image + '</a>' +
        '<div class="cart-upsells__tile-info">' +
          '<a href="/products/' + escHtml(product.handle) + '" class="cart-upsells__tile-title">' + escHtml(product.title) + '</a>' +
          '<div class="cart-upsells__tile-price">' + comparePrice + price + '</div>' +
          '<div class="cart-upsells__tile-actions">' +
            (hasOneVariant
              ? '<input type="hidden" class="cart-upsells__select" value="' + firstVariant.id + '">'
              : '<select class="cart-upsells__select" data-variant-data="' + variantData + '" aria-label="Select variant">' + options + '</select>'
            ) +
            '<button type="button" class="cart-upsells__tile-btn btn btn--small" data-upsell-add>Add</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function render(products) {
    var mounts = document.querySelectorAll(MOUNT_SELECTOR);
    if (!mounts.length) return;

    if (!products || !products.length) {
      mounts.forEach(function (m) { m.hidden = true; m.innerHTML = ''; });
      return;
    }

    var tiles = products.map(buildTile).join('');
    var markup =
      '<div class="cart-upsells__heading appear-animation appear-delay-3">You\'ll love these</div>' +
      '<div class="cart-upsells__track appear-animation appear-delay-4">' + tiles + '</div>';

    mounts.forEach(function (m) {
      m.hidden = false;
      m.innerHTML = markup;

      // Wire add buttons
      m.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); addToCart(btn); });
      });

      // Wire select → update price display
      m.querySelectorAll('.cart-upsells__select[data-variant-data]').forEach(function (sel) {
        sel.addEventListener('change', function () { updatePrice(sel); });
      });
    });
  }

  function getSelectedVariantId(btn) {
    var tile = btn.closest('.cart-upsells__tile');
    if (!tile) return null;
    var sel = tile.querySelector('.cart-upsells__select');
    return sel ? sel.value : null;
  }

  function updatePrice(sel) {
    var tile = sel.closest('.cart-upsells__tile');
    if (!tile) return;
    var variants = JSON.parse(sel.dataset.variantData.replace(/&quot;/g, '"'));
    var chosen = variants.find(function (v) { return String(v.id) === sel.value; });
    if (!chosen) return;

    var priceEl = tile.querySelector('.cart-upsells__tile-price-current');
    if (priceEl) priceEl.textContent = formatMoney(chosen.price);

    var compareEl = tile.querySelector('.cart-upsells__tile-compare');
    if (chosen.compare_at_price && chosen.compare_at_price > chosen.price) {
      if (compareEl) {
        compareEl.textContent = formatMoney(chosen.compare_at_price);
        compareEl.hidden = false;
      }
    } else if (compareEl) {
      compareEl.hidden = true;
    }
  }

  function addToCart(btn) {
    var variantId = getSelectedVariantId(btn);
    if (!variantId || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.textContent = '…';

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = '✓';
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      setTimeout(function () { btn.textContent = 'Add'; btn.classList.remove('is-loading'); }, 1500);
    })
    .catch(function () { btn.textContent = 'Add'; btn.classList.remove('is-loading'); });
  }

  function escHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function update() {
    fetchCart().then(function (cart) {
      if (!cart || !cart.item_count || !cart.items || !cart.items.length) {
        document.querySelectorAll(MOUNT_SELECTOR).forEach(function (m) { m.hidden = true; m.innerHTML = ''; });
        return;
      }
      var productId = cart.items[0].product_id;
      if (productId === lastProductId) return;
      lastProductId = productId;

      fetchRecommendations(productId).then(function (data) {
        var products = (data.products || []).filter(function (p) {
          return !cart.items.some(function (item) { return item.product_id === p.id; });
        });
        render(products.slice(0, LIMIT));
      }).catch(function () {});
    }).catch(function () {});
  }

  function init() {
    update();
    document.addEventListener('cart:updated', update);
    document.addEventListener('ajaxProduct:added', function () { lastProductId = null; update(); });
    document.addEventListener('cart:open', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
